export default {
  'errorOnBiteHistory': (coverage, biteHistory) => {
    if (coverage === 'DP2') {
      return false;
    }
    return biteHistory;
  },
  'validDwellingAnimals': (animalsInDwelling, dwellingAnimalArray) => {
    return animalsInDwelling ? (dwellingAnimalArray && dwellingAnimalArray.length > 0) : !animalsInDwelling;
  }
};
